






































































































helpers = require('../../../helpers.coffee')

view_model =
  components:
    triggerStages: require './trigger_stages.vue'
    dealLost: require './deal_lost.vue'
    propertiesMatching: require './properties_matching.vue'
    stagesMatching: require './stages_matching.vue'

  data: ->
    current_user: Session.current_user
    cv_crm_setting: if Session.current_user.cv_crm_setting.id? then Session.current_user.cv_crm_setting else new CvCrmSetting()
    add_contacts_from_cv_crm: Session.current_user.cv_crm_setting.add_contacts_from_cv_crm
    domain: Session.current_user.cv_crm_setting.domain
    email: Session.current_user.cv_crm_setting.email
    cv_crm_api_token: Session.current_user.cv_crm_api_token || ''
    url_cv_crm: 'cvcrm.com.br/api/v1/cv/'
    api_fields: []
    stage_lost: false
    integration_stages: []
    matching: []
    matching_stages: [],
    update_stages_all_users: false
    pipelines: []
    selected_pipeline: { stage_query: null }
    loading_api_key: false

  watch:
    email: ->
      @loadStages()
    domain: ->
      @loadStages()
    cv_crm_api_token: ->
      @loadStages()

  methods:
    copy: ->
      navigator.clipboard.writeText(@webhook_url);
      alertify.success(this.$t('general.actions.copied'))

    toggleMarkAddContatsFromCV: ->
      @add_contacts_from_cv_crm = !@add_contacts_from_cv_crm

    save: ->
      @$validator.validateAll({@cv_crm_api_token}).then (success) =>
        @updateCvCrmApiToken() if success

    updateCvCrmApiToken: ->
      for stage in @matching_stages
        if !stage.reev || !stage.integration
          return alertify.error(this.$t('integrations.feedback.requiredFunnelStageMap'))

      quant = { }

      for item in @matching_stages
        if item.integration != this.$t('integrations.label.ignore')
          quant[item.integration] = 0 if quant[item.integration] == undefined || quant[item.integration] == NaN
          quant[item.integration] += 1

        if quant[item.integration] > 1
          return alertify.error(this.$t('integrations.feedback.onlyIgnoreStage'))

      for property in @matching
        property.type = @api_fields.find((field) -> field.key == property.integration ).type

      metadata = @cv_crm_setting.metadata
      if @integration_stages.length > 0
        metadata['default_stage'] = @integration_stages[0].id

      Loader.on()
      params = {
        id: Session.current_user.id,
        @cv_crm_api_token,
        @update_stages_all_users,
        @user_to_update_stages,
        cv_crm_setting_attributes: {
          id: @cv_crm_setting.id,
          email: @email,
          domain: @domain,
          add_contacts_from_cv_crm: @add_contacts_from_cv_crm,
          triggers: @cv_crm_setting.triggers,
          metadata: metadata,
          properties_matching: @matching,
          stages_matching: @matching_stages,
        }
      }
      new UsersResource().update(@updateCvCrmApiTokenSuccess, @cvCrmErrors, params)

    removeCvCrmApiToken: ->
      @cv_crm_api_token = null
      @matching = []
      @matching_stages = []
      @integration_stages = []
      @cv_crm_setting.stages_matching = []
      @domain = ''
      @email = ''
      @pipelines = []
      Loader.on()
      params = {
        id: Session.current_user.id,
        @cv_crm_api_token,
        cv_crm_setting_attributes: {
          id: @cv_crm_setting.id,
          _destroy: true
        }
      }
      new UsersResource().update(@updateCvCrmApiTokenSuccess, @cvCrmErrors, params)

    updateCvCrmApiTokenSuccess: (data, response) ->
      Loader.off()
      message_action = if data.user.cv_crm_api_token then this.$t('general.actions.connectedTo') else this.$t('general.actions.disconnectedTo')
      alertify.success this.$t('integrations.feedback.cvCrmSuccess', { message_action })
      Session.signIn(response.body.user)
      @current_user = Session.current_user
      @cv_crm_api_token = data.user.cv_crm_api_token
      @domain = data.user.cv_crm_setting.domain
      @email = data.user.cv_crm_setting.email
      @cv_crm_setting.email = @email
      @cv_crm_setting.domain = @domain
      @cv_crm_setting.stage_id = data.user.cv_crm_setting.stage_id
      intercom_event_name = if data.user.cv_crm_api_token then this.$t('integrations.feedback.connectedToCvCrm') else this.$t('integrations.feedback.disconnectedToCvCrm')
      IntercomCtrl.trackEvent(intercom_event_name)

    cvCrmErrors: (response, options={}) ->
      @handleApiErrors(response, options)
      if(response.body.cv_crm_setting)
        for error in response.body.cv_crm_setting
          @errors.add(error, this.$t('general.feedback.invalid'))

    setStagesCvCrm: (data) ->
      @cv_crm_setting.triggers = data
      @update_stage_lost(data.stages)

    setMarkAs: (data) ->
      @cv_crm_setting.mark_as = data

    update_stage_lost: (stages = {}) ->
      lost_stage = stages.filter (item) -> item == 'lost'
      if lost_stage.length != 0
        return this.stage_lost = true
      return this.stage_lost = false

    matchingUpdated: (data) ->
      @matching = data.filter (field) -> 
        !(field.reev == undefined || field.reev == '')

    matchingStagesUpdated: (data) ->
      @matching_stages = data

    updateUsers: (data) ->
      @update_stages_all_users = data.update_all_users
      @user_to_update_stages = data.user_id
    
    loadStages: ->
      return if !@cv_crm_api_token || !@email || !@domain
      return if @cv_crm_api_token.length < 40
      @$http.get("https://#{@domain}.#{@url_cv_crm}workflow/leads?funcionalidade=leads", { headers: { email: @email, token: @cv_crm_api_token } }).then ((response) =>
        @integration_stages = response.body.map (situation) -> { name: situation.nome, id: situation.idsituacao }
      ), ((response) =>
      )

    closeForm: ->
      @$router.push path: '/configuracoes/integracoes'

  computed:
    lost_checked: ->
      lost_stage = @cv_crm_setting.triggers.stages.filter (item) -> item == 'lost'
      if lost_stage.length != 0
        return true
      return false

    webhook_url: ->
      return "#{process.env.API_URL}/webhooks/cv_crm/import_contacts?token=#{@current_user.authentication_token}"

  mounted: ->
    Tooltip.initialize()
    @loadStages()

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/integrations/cv_crm.vue